import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  FormFooter,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  DatePickerInput,
  ButtonAction,
  ContentBlock,
  Tag,
  Notification
} from "xsolla-uikit";
import { subsPlans } from "./data/subsPlans";

import { CssCounter } from './components/uikit2';


export const gkPlatforms = {

    steam: {
      id: "steam",
      name: "Steam",
      distr: "keys",
      added: false,
      uploaded: true,
      enabled: true,
      osName: "OS",

      icon: "",
      os: [
        { id: "windows", name: "Windows", value: true },

        { id: "mac", name: "Mac", value: true },

        { id: "linux", name: "Linux", value: false }
      ]
    }
  ,


    gog: {
    id: "gog",
    name: "GOG",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "windows", name: "Windows", value: false },

      { id: "mac", name: "Mac", value: false },

      { id: "linux", name: "Linux", value: false }
    ]}
  ,

  epic: {
    id: "epic",
    name: "Epic Games Store",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "windows", name: "Windows", value: false },

      { id: "mac", name: "Mac", value: false },

      { id: "linux", name: "Linux", value: false }
    ]
  },

  windows: {
    id: "windows",
    name: "Windows DRM-Free",
    distr: "distr",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [],
    files: [
      { id: "file1", name: "mygame_distributive_win.exe", value: false },

      { id: "file2", name: "mygame_distributive_mac.dmg", value: false },

      { id: "file3", name: "mygame_distributive_play.apk", value: false }
    ]
  },

  mac: {
    id: "mac",
    name: "Mac OS DRM-Free",
    distr: "distr",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [],
    files: [
      { id: "file1", name: "mygame_distributive_win.exe", value: false },

      { id: "file2", name: "mygame_distributive_mac.dmg", value: false },

      { id: "file3", name: "mygame_distributive_play.apk", value: false }
    ]
  },

  drmfree: {
    id: "drmfree",
    name: "DRM-Free Keys",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "windows", name: "Windows", value: false },

      { id: "mac", name: "Mac", value: false },

      { id: "linux", name: "Linux", value: false }
    ]
  },

  ps4: {
    id: "ps4",
    name: "PlayStation",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "ps4", name: "PS4", value: false },

      { id: "ps3", name: "PS3", value: false }
    ]
  },

  xbox1: {
    id: "xbox1",
    name: "XBOX",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "xbox1", name: "Xbox One", value: false },

      { id: "xbox360", name: "Xbox 360", value: false }
    ]
  },

  nintendo: {
    id: "nintendo",
    name: "Nintendo",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "switch", name: "Nintendo Switch", value: false },

      { id: "ds3ds2", name: "Nintendo 3DS/2DS", value: false }
    ]
  },

  linux: {
    id: "linux",
    name: "Linux DRM-Free",
    distr: "distr",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [],
    files: [
      { id: "file1", name: "mygame_distributive_win.exe", value: false },

      { id: "file2", name: "mygame_distributive_mac.dmg", value: false },

      { id: "file3", name: "mygame_distributive_play.apk", value: false }
    ]
  }
}



export const platforms = [
  {
    id: "steam",
    name: "Steam",
    distr: "keys",
    added: true,
    uploaded: true,
    enabled: true,
    osName: "OS",

    icon: "",
    os: [
      { id: "windows", name: "Windows", value: true },

      { id: "mac", name: "Mac", value: true },

      { id: "linux", name: "Linux", value: false }
    ]
  },

  {
    id: "gog",
    name: "GOG",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "windows", name: "Windows", value: false },

      { id: "mac", name: "Mac", value: false },

      { id: "linux", name: "Linux", value: false }
    ]
  },

  {
    id: "epic",
    name: "Epic Games Store",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "windows", name: "Windows", value: false },

      { id: "mac", name: "Mac", value: false },

      { id: "linux", name: "Linux", value: false }
    ]
  },

  {
    id: "windows",
    name: "Windows DRM-Free",
    distr: "distr",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [],
    files: [
      { id: "file1", name: "mygame_distributive_win.exe", value: false },

      { id: "file2", name: "mygame_distributive_mac.dmg", value: false },

      { id: "file3", name: "mygame_distributive_play.apk", value: false }
    ]
  },

  {
    id: "mac",
    name: "Mac OS DRM-Free",
    distr: "distr",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [],
    files: [
      { id: "file1", name: "mygame_distributive_win.exe", value: false },

      { id: "file2", name: "mygame_distributive_mac.dmg", value: false },

      { id: "file3", name: "mygame_distributive_play.apk", value: false }
    ]
  },

  {
    id: "drmfree",
    name: "DRM-Free Keys",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "windows", name: "Windows", value: false },

      { id: "mac", name: "Mac", value: false },

      { id: "linux", name: "Linux", value: false }
    ]
  },

  {
    id: "ps4",
    name: "PlayStation",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "ps4", name: "PS4", value: false },

      { id: "ps3", name: "PS3", value: false }
    ]
  },

  {
    id: "xbox1",
    name: "XBOX",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "xbox1", name: "Xbox One", value: false },

      { id: "xbox360", name: "Xbox 360", value: false }
    ]
  },

  {
    id: "nintendo",
    name: "Nintendo",
    distr: "keys",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [
      { id: "switch", name: "Nintendo Switch", value: false },

      { id: "ds3ds2", name: "Nintendo 3DS/2DS", value: false }
    ]
  },

  {
    id: "linux",
    name: "Linux DRM-Free",
    distr: "distr",
    added: false,
    uploaded: false,
    enabled: false,
    osName: "OS",

    icon: "",
    os: [],
    files: [
      { id: "file1", name: "mygame_distributive_win.exe", value: false },

      { id: "file2", name: "mygame_distributive_mac.dmg", value: false },

      { id: "file3", name: "mygame_distributive_play.apk", value: false }
    ]
  }
];




export const subscriptionStatuses = [
  {
    label: "All statuses",
    value: "all",
    iconAlign: 'right',
  },
  {
    label: <StatusDot status="enabled">Active</StatusDot>,
    customIcon: <CssCounter>12.023</CssCounter>,
    iconAlign: 'right',
    value: "active",
  },
  {
    label: <StatusDot status="disabled">Canceled</StatusDot>,
    value: "canceled",
    customIcon: <CssCounter>3</CssCounter>,
    iconAlign: 'right',
  },
  {
    label: <StatusDot status="testing">Non renewing</StatusDot>,
    value: "renewing",
    customIcon: <CssCounter>12</CssCounter>,
    iconAlign: 'right',
  },
  {
    label: <StatusDot status="processing-outline">In trial</StatusDot>,
    value: "trial",
    customIcon: <CssCounter>0</CssCounter>,
    iconAlign: 'right',
  },
  {
    label: <StatusDot status="error">Expired</StatusDot>,
    value: "expired",
    customIcon: <CssCounter>354</CssCounter>,
    iconAlign: 'right',
  }
]






export const getUserAvatars = (factor = 1.2) => {
  if (Math.floor(Math.random() * factor * 10) > 1) {
    return userAvatars[Math.floor(Math.random() * userAvatars.length)];
  } else {
    return "https://innmind.com/assets/placeholders/no_avatar-3d6725770296b6a1cce653a203d8f85dcc5298945b71fa7360e3d9aa4a3fc054.svg";
  }
};



export const getFakeSubs = (typ) => {
  return subsPlans[Math.floor(Math.random() * subsPlans.length)];
};



export const getFakeAuths = (typ) => {
  const auths = [
    {
      label: 'Email/password',
    },
    {
      label: 'Google',
    },
    {
      label: 'Wechat',
    },
  ]
  return auths[Math.floor(Math.random() * auths.length)];
};



export const sources = [
  {
    id: 'purchase',
    type: 'Purchase',
    label: 'My game Ultimate Edition',
    extraLabel: 'Purchase',
  },
  {
    id: 'purchase1',
    type: 'Purchase',
    label: 'My game Collectors Edition',
    extraLabel: 'Purchase',
  },
  {
    id: 'purchase2',
    type: 'Purchase',
    label: 'My game',
    extraLabel: 'Purchase',
  },
  {
    id: 'subscribe',
    type: 'Subscribe',
    label: 'mygame.com',
    extraLabel: 'Subscribe',
  },
  {
    id: 'signup',
    type: 'Sign up',
    label: 'mygame.com',
    extraLabel: 'Sign up',
  },
]
export const getFakeSource = (typ) => {

  return sources[Math.floor(Math.random() * sources.length)];
};



export const getFakeStatuses = (typ) => {
  let fakeSubs = [
    {
      label: <StatusDot status="enabled">Active</StatusDot>,
      title: 'Active',
      customIcon: <CssCounter>12.023</CssCounter>,
      appearance: 'active',
      iconAlign: 'right',
      value: "active",
      status: "enabled",
    },
    {
      label: <StatusDot status="disabled">Canceled</StatusDot>,
      title: 'Canceled',
      value: "canceled",
      appearance: 'error',
      customIcon: <CssCounter>3</CssCounter>,
      iconAlign: 'right',
      status: "disabled",
    },
    {
      label: <StatusDot status="testing">Non renewing</StatusDot>,
      title: 'Non renewing',
      appearance: 'info',
      value: "renewing",
      customIcon: <CssCounter>12</CssCounter>,
      iconAlign: 'right',
      status: "testing",
    },
    {
      label: <StatusDot status="processing-outline">In trial</StatusDot>,
      title: 'In trial',
      value: "trial",
      appearance: 'warning',
      customIcon: <CssCounter>20.021</CssCounter>,
      iconAlign: 'right',
      status: "processing-outline",
    },
    {
      label: <StatusDot status="error">Expired</StatusDot>,
      title: 'Expired',
      value: "expired",
      appearance: 'error',
      customIcon: <CssCounter>354</CssCounter>,
      iconAlign: 'right',
      status: "error",
    },
  ];

  if (typ) fakeSubs = fakeSubs.filter(oneSub => oneSub['value'] === typ);

  return fakeSubs[Math.floor(Math.random() * fakeSubs.length)];
};



export const userAvatars = [
  "https://randomuser.me/api/portraits/women/18.jpg",
  "https://randomuser.me/api/portraits/women/42.jpg",
  "https://randomuser.me/api/portraits/women/81.jpg",
  "https://randomuser.me/api/portraits/women/10.jpg",
  "https://randomuser.me/api/portraits/women/79.jpg",
  "https://randomuser.me/api/portraits/women/92.jpg",
  "https://randomuser.me/api/portraits/women/61.jpg",
  "https://randomuser.me/api/portraits/women/30.jpg",
  "https://randomuser.me/api/portraits/women/87.jpg",
  "https://randomuser.me/api/portraits/women/85.jpg",
  "https://randomuser.me/api/portraits/women/47.jpg",
  "https://randomuser.me/api/portraits/women/35.jpg",
  "https://randomuser.me/api/portraits/women/19.jpg",
  "https://randomuser.me/api/portraits/women/49.jpg",
  "https://randomuser.me/api/portraits/women/54.jpg",
  "https://randomuser.me/api/portraits/women/14.jpg",
  "https://randomuser.me/api/portraits/women/67.jpg",
  "https://randomuser.me/api/portraits/women/86.jpg",
  "https://randomuser.me/api/portraits/women/22.jpg",
  "https://randomuser.me/api/portraits/women/2.jpg",
  "https://randomuser.me/api/portraits/women/69.jpg",
  "https://randomuser.me/api/portraits/women/53.jpg",
  "https://randomuser.me/api/portraits/women/55.jpg",
  "https://randomuser.me/api/portraits/women/60.jpg",
  "https://randomuser.me/api/portraits/women/5.jpg",
  "https://randomuser.me/api/portraits/women/37.jpg",
  "https://randomuser.me/api/portraits/women/93.jpg",
  "https://randomuser.me/api/portraits/women/88.jpg",
  "https://randomuser.me/api/portraits/women/94.jpg",
  "https://randomuser.me/api/portraits/women/1.jpg",
  "https://randomuser.me/api/portraits/women/46.jpg",
  "https://randomuser.me/api/portraits/women/51.jpg",
  "https://randomuser.me/api/portraits/women/29.jpg",
  "https://randomuser.me/api/portraits/women/62.jpg",
  "https://randomuser.me/api/portraits/women/90.jpg",
  "https://randomuser.me/api/portraits/women/66.jpg",
  "https://randomuser.me/api/portraits/women/20.jpg",
  "https://randomuser.me/api/portraits/women/0.jpg",
  "https://randomuser.me/api/portraits/women/68.jpg",
  "https://randomuser.me/api/portraits/women/80.jpg",
  "https://randomuser.me/api/portraits/women/3.jpg",
  "https://randomuser.me/api/portraits/women/25.jpg",
  "https://randomuser.me/api/portraits/women/8.jpg",
  "https://randomuser.me/api/portraits/women/74.jpg",
  "https://randomuser.me/api/portraits/women/65.jpg",
  "https://randomuser.me/api/portraits/women/72.jpg",
  "https://randomuser.me/api/portraits/women/70.jpg",
  "https://randomuser.me/api/portraits/women/31.jpg",
  "https://randomuser.me/api/portraits/women/76.jpg",
  "https://randomuser.me/api/portraits/women/73.jpg",
  "https://randomuser.me/api/portraits/women/16.jpg",
  "https://randomuser.me/api/portraits/women/4.jpg",
  "https://randomuser.me/api/portraits/women/89.jpg",
  "https://randomuser.me/api/portraits/women/13.jpg",
  "https://randomuser.me/api/portraits/women/24.jpg",
  "https://randomuser.me/api/portraits/women/44.jpg",
  "https://randomuser.me/api/portraits/women/17.jpg",
  "https://randomuser.me/api/portraits/women/58.jpg",
  "https://randomuser.me/api/portraits/women/21.jpg",
  "https://randomuser.me/api/portraits/women/9.jpg",
  "https://randomuser.me/api/portraits/women/23.jpg",
  "https://randomuser.me/api/portraits/women/33.jpg",
  "https://randomuser.me/api/portraits/women/59.jpg",
  "https://randomuser.me/api/portraits/women/38.jpg",
  "https://randomuser.me/api/portraits/women/34.jpg",
  "https://randomuser.me/api/portraits/women/26.jpg",
  "https://randomuser.me/api/portraits/women/12.jpg",
  "https://randomuser.me/api/portraits/women/36.jpg",
  "https://randomuser.me/api/portraits/women/77.jpg",
  "https://randomuser.me/api/portraits/women/83.jpg",
  "https://randomuser.me/api/portraits/women/50.jpg",
  "https://randomuser.me/api/portraits/women/39.jpg",
  "https://randomuser.me/api/portraits/women/82.jpg",
  "https://randomuser.me/api/portraits/women/75.jpg",
  "https://randomuser.me/api/portraits/women/6.jpg",
  "https://randomuser.me/api/portraits/women/28.jpg",
  "https://randomuser.me/api/portraits/women/32.jpg",
  "https://randomuser.me/api/portraits/women/11.jpg",
  "https://randomuser.me/api/portraits/women/57.jpg",
  "https://randomuser.me/api/portraits/women/91.jpg",
  "https://randomuser.me/api/portraits/women/41.jpg",
  "https://randomuser.me/api/portraits/women/71.jpg",
  "https://randomuser.me/api/portraits/women/63.jpg",
  "https://randomuser.me/api/portraits/women/48.jpg",
  "https://randomuser.me/api/portraits/women/52.jpg",
  "https://randomuser.me/api/portraits/women/64.jpg",
  "https://randomuser.me/api/portraits/women/78.jpg",
  "https://randomuser.me/api/portraits/women/15.jpg",
  "https://randomuser.me/api/portraits/women/7.jpg",
  "https://randomuser.me/api/portraits/women/43.jpg",
  "https://randomuser.me/api/portraits/women/27.jpg",
  "https://randomuser.me/api/portraits/women/45.jpg",
  "https://randomuser.me/api/portraits/women/40.jpg",
  "https://randomuser.me/api/portraits/women/84.jpg",
  "https://randomuser.me/api/portraits/women/56.jpg",
  "https://randomuser.me/api/portraits/women/undefined.jpg",
  "https://randomuser.me/api/portraits/men/67.jpg",
  "https://randomuser.me/api/portraits/men/51.jpg",
  "https://randomuser.me/api/portraits/men/58.jpg",
  "https://randomuser.me/api/portraits/men/2.jpg",
  "https://randomuser.me/api/portraits/men/25.jpg",
  "https://randomuser.me/api/portraits/men/63.jpg",
  "https://randomuser.me/api/portraits/men/49.jpg",
  "https://randomuser.me/api/portraits/men/84.jpg",
  "https://randomuser.me/api/portraits/men/91.jpg",
  "https://randomuser.me/api/portraits/men/17.jpg",
  "https://randomuser.me/api/portraits/men/57.jpg",
  "https://randomuser.me/api/portraits/men/69.jpg",
  "https://randomuser.me/api/portraits/men/81.jpg",
  "https://randomuser.me/api/portraits/men/76.jpg",
  "https://randomuser.me/api/portraits/men/32.jpg",
  "https://randomuser.me/api/portraits/men/6.jpg",
  "https://randomuser.me/api/portraits/men/8.jpg",
  "https://randomuser.me/api/portraits/men/62.jpg",
  "https://randomuser.me/api/portraits/men/12.jpg",
  "https://randomuser.me/api/portraits/men/65.jpg",
  "https://randomuser.me/api/portraits/men/46.jpg",
  "https://randomuser.me/api/portraits/men/68.jpg",
  "https://randomuser.me/api/portraits/men/35.jpg",
  "https://randomuser.me/api/portraits/men/0.jpg",
  "https://randomuser.me/api/portraits/men/64.jpg",
  "https://randomuser.me/api/portraits/men/19.jpg",
  "https://randomuser.me/api/portraits/men/80.jpg",
  "https://randomuser.me/api/portraits/men/47.jpg",
  "https://randomuser.me/api/portraits/men/42.jpg",
  "https://randomuser.me/api/portraits/men/78.jpg",
  "https://randomuser.me/api/portraits/men/93.jpg",
  "https://randomuser.me/api/portraits/men/73.jpg",
  "https://randomuser.me/api/portraits/men/74.jpg",
  "https://randomuser.me/api/portraits/men/13.jpg",
  "https://randomuser.me/api/portraits/men/37.jpg",
  "https://randomuser.me/api/portraits/men/39.jpg",
  "https://randomuser.me/api/portraits/men/75.jpg",
  "https://randomuser.me/api/portraits/men/82.jpg",
  "https://randomuser.me/api/portraits/men/92.jpg",
  "https://randomuser.me/api/portraits/men/60.jpg",
  "https://randomuser.me/api/portraits/men/3.jpg",
  "https://randomuser.me/api/portraits/men/89.jpg",
  "https://randomuser.me/api/portraits/men/18.jpg",
  "https://randomuser.me/api/portraits/men/41.jpg",
  "https://randomuser.me/api/portraits/men/26.jpg",
  "https://randomuser.me/api/portraits/men/85.jpg",
  "https://randomuser.me/api/portraits/men/22.jpg",
  "https://randomuser.me/api/portraits/men/28.jpg",
  "https://randomuser.me/api/portraits/men/38.jpg",
  "https://randomuser.me/api/portraits/men/54.jpg",
  "https://randomuser.me/api/portraits/men/7.jpg",
  "https://randomuser.me/api/portraits/men/77.jpg",
  "https://randomuser.me/api/portraits/men/30.jpg",
  "https://randomuser.me/api/portraits/men/5.jpg",
  "https://randomuser.me/api/portraits/men/44.jpg",
  "https://randomuser.me/api/portraits/men/71.jpg",
  "https://randomuser.me/api/portraits/men/79.jpg",
  "https://randomuser.me/api/portraits/men/27.jpg",
  "https://randomuser.me/api/portraits/men/16.jpg",
  "https://randomuser.me/api/portraits/men/70.jpg",
  "https://randomuser.me/api/portraits/men/24.jpg",
  "https://randomuser.me/api/portraits/men/61.jpg",
  "https://randomuser.me/api/portraits/men/59.jpg",
  "https://randomuser.me/api/portraits/men/72.jpg",
  "https://randomuser.me/api/portraits/men/34.jpg",
  "https://randomuser.me/api/portraits/men/45.jpg",
  "https://randomuser.me/api/portraits/men/29.jpg",
  "https://randomuser.me/api/portraits/men/90.jpg",
  "https://randomuser.me/api/portraits/men/9.jpg",
  "https://randomuser.me/api/portraits/men/94.jpg",
  "https://randomuser.me/api/portraits/men/55.jpg",
  "https://randomuser.me/api/portraits/men/1.jpg",
  "https://randomuser.me/api/portraits/men/40.jpg",
  "https://randomuser.me/api/portraits/men/31.jpg",
  "https://randomuser.me/api/portraits/men/86.jpg",
  "https://randomuser.me/api/portraits/men/50.jpg",
  "https://randomuser.me/api/portraits/men/53.jpg",
  "https://randomuser.me/api/portraits/men/43.jpg",
  "https://randomuser.me/api/portraits/men/11.jpg",
  "https://randomuser.me/api/portraits/men/33.jpg",
  "https://randomuser.me/api/portraits/men/15.jpg",
  "https://randomuser.me/api/portraits/men/14.jpg",
  "https://randomuser.me/api/portraits/men/20.jpg",
  "https://randomuser.me/api/portraits/men/4.jpg",
  "https://randomuser.me/api/portraits/men/56.jpg",
  "https://randomuser.me/api/portraits/men/36.jpg",
  "https://randomuser.me/api/portraits/men/83.jpg",
  "https://randomuser.me/api/portraits/men/52.jpg",
  "https://randomuser.me/api/portraits/men/21.jpg",
  "https://randomuser.me/api/portraits/men/87.jpg",
  "https://randomuser.me/api/portraits/men/88.jpg",
  "https://randomuser.me/api/portraits/men/66.jpg",
  "https://randomuser.me/api/portraits/men/48.jpg",
  "https://randomuser.me/api/portraits/men/10.jpg",
  "https://randomuser.me/api/portraits/men/undefined.jpg",
  "https://randomuser.me/api/portraits/men/undefined.jpg",
  "https://randomuser.me/api/portraits/men/undefined.jpg",
  "https://randomuser.me/api/portraits/men/undefined.jpg",
  "https://randomuser.me/api/portraits/men/undefined.jpg"
];

export const vi = [
  {
    id: 159428,
    sku: "gun_1",
    localized_name: "Xsolla Basic Blaster 1",
    prices: {
      USD: 1.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
    advertisement_type: null
  },
  {
    id: 160293,
    sku: "gun_2",
    localized_name: "Empire Basic Blaster",
    prices: {
      USD: 1.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/0022d709c53e8ab27ff4c3b2aacda9af.png",
    advertisement_type: null
  },
  {
    id: 159444,
    sku: "rocket_launcher_1",
    localized_name: "Xsolla Rocket Launcher",
    prices: {
      USD: 19.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/c86a1227d14c41e5a44db6c2ab4348de.png",
    advertisement_type: null
  },
  {
    id: 160131,
    sku: "rocket_launcher_2",
    localized_name: "Empire Rocket Launcher",
    prices: {
      USD: 19.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/73f6060f23b0daac38ed345b1cc48a28.png",
    advertisement_type: null
  },
  {
    id: 160319,
    sku: "lootbox_1",
    localized_name: "Xsolla Lootbox",
    prices: {
      USD: 2.5
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/9452770924475de851ac8129168c3e98.png",
    advertisement_type: null
  },
  {
    id: 160295,
    sku: "lootbox_2",
    localized_name: "Empire Lootbox",
    prices: {
      USD: 2.5
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/685b21f9d9dca4aa0c953e8816b4eb4b.png",
    advertisement_type: null
  },
  {
    id: 159432,
    sku: "keys_1",
    localized_name: "Xsolla Key",
    prices: {
      USD: 2.5
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/3d04bfe21d16d9d790d127ff1a9ebfd5.png",
    advertisement_type: null
  },
  {
    id: 160296,
    sku: "keys_2",
    localized_name: "Empire Key",
    prices: {
      USD: 2.5
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/5c2f8536f08a9949964e4fa2e01a7cb8.png",
    advertisement_type: null
  },
  {
    id: 159435,
    sku: "swords_1",
    localized_name: "Xsolla Swords",
    prices: {
      USD: 4.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/8ab44fe99038a56de01950ba4a971b77.png",
    advertisement_type: null
  },
  {
    id: 160297,
    sku: "swords_2",
    localized_name: "Empire Swords",
    prices: {
      USD: 4.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/23b89b405724c8b1cb39aebc95a090db.png",
    advertisement_type: null
  },
  {
    id: 160142,
    sku: "booster_mega_1",
    localized_name: "Xsolla Booster Mega",
    prices: {
      USD: 100
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/e9f2f4a634bc96ea03b5d5ceadd7c55f.png",
    advertisement_type: null
  },
  {
    id: 160298,
    sku: "booster_mega_2",
    localized_name: "Empire Booster Mega",
    prices: {
      USD: 100
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/55e908cb9670301ac8f89a6382433a27.png",
    advertisement_type: null
  },
  {
    id: 159431,
    sku: "booster_min_1",
    localized_name: "Xsolla Booster Mini",
    prices: {
      USD: 6.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/5ee252b292a560930c8f7e2c791dfc6d.png",
    advertisement_type: null
  },
  {
    id: 160299,
    sku: "booster_min_2",
    localized_name: "Empire Booster Mini",
    prices: {
      USD: 6.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/5bcecec17400a0d8c72dd265ff730b07.png",
    advertisement_type: null
  },
  {
    id: 159437,
    sku: "xsolla_gloves",
    localized_name: "Xsolla Gloves",
    prices: {
      USD: 1.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/93a7ee3ae284b677d3dc1f2e989731cb.png",
    advertisement_type: null
  },
  {
    id: 160300,
    sku: "gloves_2",
    localized_name: "Empire Gloves",
    prices: {
      USD: 1.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/4cdc4244cb517abd67f6091e01c1ae0a.png",
    advertisement_type: null
  },
  {
    id: 160145,
    sku: "minigun_1",
    localized_name: "Xsolla Minigun",
    prices: {
      USD: 29.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/2fc5c491a47413a8e8000447889093c2.png",
    advertisement_type: null
  },
  {
    id: 160301,
    sku: "minigun_2",
    localized_name: "Empire Minigun",
    prices: {
      USD: 29.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/dabfa4567cd2d82e0562d4b0f448b436.png",
    advertisement_type: null
  },
  {
    id: 159442,
    sku: "shield_max_1",
    localized_name: "Xsolla Maximum Shield",
    prices: {
      USD: 9.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/72df8c646b75cc8144c1a8b363c08bc5.png",
    advertisement_type: null
  },
  {
    id: 160309,
    sku: "shield_max_2",
    localized_name: "Empire Maximum Shield",
    prices: {
      USD: 9.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/17436068f06426999af0858edfb9072d.png",
    advertisement_type: null
  },
  {
    id: 159518,
    sku: "shield_min_1",
    localized_name: "Xsolla Small Shield",
    prices: {
      USD: 5.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/cf8021e9bcd5eb25aaa8f7f72ff0311a.png",
    advertisement_type: null
  },
  {
    id: 160302,
    sku: "shield_min_2",
    localized_name: "Empire Small Shield",
    prices: {
      USD: 5.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/a4003423673b489a5d99f23800e65faa.png",
    advertisement_type: null
  },
  {
    id: 159429,
    sku: "helmet_1",
    localized_name: "Xsolla Helmet",
    prices: {
      USD: 2.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/b79342cdf24f0f8557b63c87e8326e62.png",
    advertisement_type: null
  },
  {
    id: 160314,
    sku: "helmet_2",
    localized_name: "Empire Helmet",
    prices: {
      USD: 2.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/86a89eb32fcf897b98908d73ac3458c1.png",
    advertisement_type: null
  },
  {
    id: 159436,
    sku: "armor_max_1",
    localized_name: "Xsolla Maximum Armor",
    prices: {
      USD: 12.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/5c3b8b45c5be5fe7803e59fbc8041be4.png",
    advertisement_type: null
  },
  {
    id: 160310,
    sku: "armor_max_2",
    localized_name: "Empire Maximum Armor",
    prices: {
      USD: 12.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/67d647ad4f4e9a905bd552b0408db8a8.png",
    advertisement_type: null
  },
  {
    id: 159438,
    sku: "armor_med_1",
    localized_name: "Xsolla Medium Armor",
    prices: {
      USD: 4.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/7f6e216f8fcc3c1796162897c2b0db01.png",
    advertisement_type: null
  },
  {
    id: 160311,
    sku: "armor_med_2",
    localized_name: "Empire Medium Armor",
    prices: {
      USD: 4.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/737b4c93205dc774f47dda1f73037734.png",
    advertisement_type: null
  },
  {
    id: 160312,
    sku: "armor_min_1",
    localized_name: "Xsolla Minimum Armor",
    prices: {
      USD: 2.5
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/bb55c047e2a97f629f4e0971da171db0.png",
    advertisement_type: null
  },
  {
    id: 160313,
    sku: "armor_min_2",
    localized_name: "Empire Minimum Armor",
    prices: {
      USD: 2.5
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/335125dbe1d461a7e70825b7ac599fd1.png",
    advertisement_type: null
  },
  {
    id: 160316,
    sku: "dog_1",
    localized_name: "Xsolla DogBot",
    prices: {
      USD: 14.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/10c41787f86b81007a3b5043dca8c553.png",
    advertisement_type: null
  },
  {
    id: 160315,
    sku: "dog_2",
    localized_name: "Empire DogBot",
    prices: {
      USD: 14.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/4f8fdd2037248ec2d5c10f78f6e6b2d4.png",
    advertisement_type: null
  },
  {
    id: 159440,
    sku: "glasses_1",
    localized_name: "Xsolla Glasses",
    prices: {
      USD: 1.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/c4598e1925673d360d24461440cc214e.png",
    advertisement_type: null
  },
  {
    id: 160317,
    sku: "glasses_2",
    localized_name: "Empire Glasses",
    prices: {
      USD: 1.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/2594a0a6997edebb8e1a9c62e20f856e.png",
    advertisement_type: null
  },
  {
    id: 159439,
    sku: "boots_1",
    localized_name: "Xsolla Boots",
    prices: {
      USD: 2.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/6e33d40df3cdac152dac9ac3d1f5986e.png",
    advertisement_type: null
  },
  {
    id: 160318,
    sku: "boots_2",
    localized_name: "Empire Boots",
    prices: {
      USD: 2.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/9a10933af8739f908f3456a06bbe4056.png",
    advertisement_type: null
  },
  {
    id: 159443,
    sku: "gun_max",
    localized_name: "Xsolla Gun",
    prices: {
      USD: 11.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/3093eeb39d5ec7def3af6396607a30ba.png",
    advertisement_type: null
  },
  {
    id: 159441,
    sku: "Sword",
    localized_name: "Xsolla Sword",
    prices: {
      USD: 2.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/ed1179ac76acf5e695bf0d9b8816e00c.png",
    advertisement_type: null
  },
  {
    id: 159434,
    sku: "lootbox_max",
    localized_name: "Xsolla Lootbox Max",
    prices: {
      USD: 12.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/779d2588a5b3cf348133fa7d5755cec8.png",
    advertisement_type: null
  },
  {
    id: 159433,
    sku: "booster_min",
    localized_name: "Booster",
    prices: {
      USD: 3.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/e76d317ee5a8d06a4b730bcf23746e9e.png",
    advertisement_type: null
  },
  {
    id: 159430,
    sku: "lootbox_0",
    localized_name: "Xsolla Loot Box",
    prices: {
      USD: 9.99
    },
    virtual_currency_price: null,
    default_currency: "USD",
    enabled: true,
    permanent: false,
    image_url:
      "//cdn3.xsolla.com/img/misc/images/9676f06265375087e607cb79c5283688.png",
    advertisement_type: null
  }
];





export const vpromos = [
  {
      "id": 19520,
      "project_id": 37471,
      "project": {
          "id": 37471,
          "localized_name": "Xsolla Store React (xsolla-react-store)"
      },
      "technical_name": "Promotion",
      "name": {
          "en": "SHORT2"
      },
      "description": {
          "en": "SHORT2"
      },
      "label": null,
      "read_only": true,
      "enabled": true,
      "is_active": false,
      "is_infinite": false,
      "show_banner": true,
      "timezone": "-07:00",
      "datetime": null,
      "periods": [
          {
              "from": "2019-09-17T13:06:58",
              "to": "2019-09-17T13:08:00"
          },
          {
              "from": "2019-09-17T13:07:16",
              "to": "2019-09-18T12:00:00"
          }
      ],
      "subject": {
          "id": 19520,
          "purchase": true,
          "items": null,
          "packages": null,
          "subscriptions": null,
          "digital_contents": null
      },
      "rewards": {
          "id": 19520,
          "purchase": {
              "discount_percent": 90
          },
          "package": {
              "bonus_percent": null,
              "bonus_amount": null
          },
          "item": {
              "discount": [],
              "bonus": []
          },
          "subscription": {
              "trial_days": null
          }
      },
      "payment_systems": [],
      "payments_count": {
          "minimum": null,
          "maximum": null
      },
      "user_attributes": [],
      "campaigns": [],
      "has_different_offsets": false
  },
  {
    "id": 19520,
    "project_id": 37471,
    "project": {
        "id": 37471,
        "localized_name": "Xsolla Store React (xsolla-react-store)"
    },
    "technical_name": "Test promo",
    "name": {
        "en": "SHORT2"
    },
    "description": {
        "en": "SHORT2"
    },
    "label": null,
    "read_only": true,
    "enabled": false,
    "is_active": false,
    "is_infinite": false,
    "show_banner": true,
    "timezone": "-07:00",
    "datetime": null,
    "periods": [
        {
            "from": "2019-09-17T13:06:58",
            "to": "2019-09-17T13:08:00"
        },
        {
            "from": "2019-09-17T13:07:16",
            "to": "2019-09-18T12:00:00"
        }
    ],
    "subject": {
        "id": 19520,
        "purchase": true,
        "items": null,
        "packages": null,
        "subscriptions": null,
        "digital_contents": null
    },
    "rewards": {
        "id": 19520,
        "purchase": {
            "discount_percent": 90
        },
        "package": {
            "bonus_percent": null,
            "bonus_amount": null
        },
        "item": {
            "discount": [],
            "bonus": []
        },
        "subscription": {
            "trial_days": null
        }
    },
    "payment_systems": [],
    "payments_count": {
        "minimum": null,
        "maximum": null
    },
    "user_attributes": [],
    "campaigns": [],
    "has_different_offsets": false
  },
]


export const subs = []







export const currencies = {
  "USD": {
      "symbol": "$",
      "name": "US Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "USD",
      "name_plural": "US dollars"
  },
  "CAD": {
      "symbol": "CA$",
      "name": "Canadian Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CAD",
      "name_plural": "Canadian dollars"
  },
  "EUR": {
      "symbol": "€",
      "name": "Euro",
      "symbol_native": "€",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "EUR",
      "name_plural": "euros"
  },
  "AED": {
      "symbol": "AED",
      "name": "United Arab Emirates Dirham",
      "symbol_native": "د.إ.‏",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "AED",
      "name_plural": "UAE dirhams"
  },
  "AFN": {
      "symbol": "Af",
      "name": "Afghan Afghani",
      "symbol_native": "؋",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "AFN",
      "name_plural": "Afghan Afghanis"
  },
  "ALL": {
      "symbol": "ALL",
      "name": "Albanian Lek",
      "symbol_native": "Lek",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "ALL",
      "name_plural": "Albanian lekë"
  },
  "AMD": {
      "symbol": "AMD",
      "name": "Armenian Dram",
      "symbol_native": "դր.",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "AMD",
      "name_plural": "Armenian drams"
  },
  "ARS": {
      "symbol": "AR$",
      "name": "Argentine Peso",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "ARS",
      "name_plural": "Argentine pesos"
  },
  "AUD": {
      "symbol": "AU$",
      "name": "Australian Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "AUD",
      "name_plural": "Australian dollars"
  },
  "AZN": {
      "symbol": "man.",
      "name": "Azerbaijani Manat",
      "symbol_native": "ман.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "AZN",
      "name_plural": "Azerbaijani manats"
  },
  "BAM": {
      "symbol": "KM",
      "name": "Bosnia-Herzegovina Convertible Mark",
      "symbol_native": "KM",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BAM",
      "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
      "symbol": "Tk",
      "name": "Bangladeshi Taka",
      "symbol_native": "৳",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BDT",
      "name_plural": "Bangladeshi takas"
  },
  "BGN": {
      "symbol": "BGN",
      "name": "Bulgarian Lev",
      "symbol_native": "лв.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BGN",
      "name_plural": "Bulgarian leva"
  },
  "BHD": {
      "symbol": "BD",
      "name": "Bahraini Dinar",
      "symbol_native": "د.ب.‏",
      "decimal_digits": 3,
      "rounding": 0,
      "code": "BHD",
      "name_plural": "Bahraini dinars"
  },
  "BIF": {
      "symbol": "FBu",
      "name": "Burundian Franc",
      "symbol_native": "FBu",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "BIF",
      "name_plural": "Burundian francs"
  },
  "BND": {
      "symbol": "BN$",
      "name": "Brunei Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BND",
      "name_plural": "Brunei dollars"
  },
  "BOB": {
      "symbol": "Bs",
      "name": "Bolivian Boliviano",
      "symbol_native": "Bs",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BOB",
      "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
      "symbol": "R$",
      "name": "Brazilian Real",
      "symbol_native": "R$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BRL",
      "name_plural": "Brazilian reals"
  },
  "BWP": {
      "symbol": "BWP",
      "name": "Botswanan Pula",
      "symbol_native": "P",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BWP",
      "name_plural": "Botswanan pulas"
  },
  "BYR": {
      "symbol": "BYR",
      "name": "Belarusian Ruble",
      "symbol_native": "BYR",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "BYR",
      "name_plural": "Belarusian rubles"
  },
  "BZD": {
      "symbol": "BZ$",
      "name": "Belize Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "BZD",
      "name_plural": "Belize dollars"
  },
  "CDF": {
      "symbol": "CDF",
      "name": "Congolese Franc",
      "symbol_native": "FrCD",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CDF",
      "name_plural": "Congolese francs"
  },
  "CHF": {
      "symbol": "CHF",
      "name": "Swiss Franc",
      "symbol_native": "CHF",
      "decimal_digits": 2,
      "rounding": 0.05,
      "code": "CHF",
      "name_plural": "Swiss francs"
  },
  "CLP": {
      "symbol": "CL$",
      "name": "Chilean Peso",
      "symbol_native": "$",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "CLP",
      "name_plural": "Chilean pesos"
  },
  "CNY": {
      "symbol": "CN¥",
      "name": "Chinese Yuan",
      "symbol_native": "CN¥",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CNY",
      "name_plural": "Chinese yuan"
  },
  "COP": {
      "symbol": "CO$",
      "name": "Colombian Peso",
      "symbol_native": "$",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "COP",
      "name_plural": "Colombian pesos"
  },
  "CRC": {
      "symbol": "₡",
      "name": "Costa Rican Colón",
      "symbol_native": "₡",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "CRC",
      "name_plural": "Costa Rican colóns"
  },
  "CVE": {
      "symbol": "CV$",
      "name": "Cape Verdean Escudo",
      "symbol_native": "CV$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CVE",
      "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
      "symbol": "Kč",
      "name": "Czech Republic Koruna",
      "symbol_native": "Kč",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "CZK",
      "name_plural": "Czech Republic korunas"
  },
  "DJF": {
      "symbol": "Fdj",
      "name": "Djiboutian Franc",
      "symbol_native": "Fdj",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "DJF",
      "name_plural": "Djiboutian francs"
  },
  "DKK": {
      "symbol": "Dkr",
      "name": "Danish Krone",
      "symbol_native": "kr",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "DKK",
      "name_plural": "Danish kroner"
  },
  "DOP": {
      "symbol": "RD$",
      "name": "Dominican Peso",
      "symbol_native": "RD$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "DOP",
      "name_plural": "Dominican pesos"
  },
  "DZD": {
      "symbol": "DA",
      "name": "Algerian Dinar",
      "symbol_native": "د.ج.‏",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "DZD",
      "name_plural": "Algerian dinars"
  },
  "EEK": {
      "symbol": "Ekr",
      "name": "Estonian Kroon",
      "symbol_native": "kr",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "EEK",
      "name_plural": "Estonian kroons"
  },
  "EGP": {
      "symbol": "EGP",
      "name": "Egyptian Pound",
      "symbol_native": "ج.م.‏",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "EGP",
      "name_plural": "Egyptian pounds"
  },
  "ERN": {
      "symbol": "Nfk",
      "name": "Eritrean Nakfa",
      "symbol_native": "Nfk",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "ERN",
      "name_plural": "Eritrean nakfas"
  },
  "ETB": {
      "symbol": "Br",
      "name": "Ethiopian Birr",
      "symbol_native": "Br",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "ETB",
      "name_plural": "Ethiopian birrs"
  },
  "GBP": {
      "symbol": "£",
      "name": "British Pound Sterling",
      "symbol_native": "£",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "GBP",
      "name_plural": "British pounds sterling"
  },
  "GEL": {
      "symbol": "GEL",
      "name": "Georgian Lari",
      "symbol_native": "GEL",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "GEL",
      "name_plural": "Georgian laris"
  },
  "GHS": {
      "symbol": "GH₵",
      "name": "Ghanaian Cedi",
      "symbol_native": "GH₵",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "GHS",
      "name_plural": "Ghanaian cedis"
  },
  "GNF": {
      "symbol": "FG",
      "name": "Guinean Franc",
      "symbol_native": "FG",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "GNF",
      "name_plural": "Guinean francs"
  },
  "GTQ": {
      "symbol": "GTQ",
      "name": "Guatemalan Quetzal",
      "symbol_native": "Q",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "GTQ",
      "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
      "symbol": "HK$",
      "name": "Hong Kong Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "HKD",
      "name_plural": "Hong Kong dollars"
  },
  "HNL": {
      "symbol": "HNL",
      "name": "Honduran Lempira",
      "symbol_native": "L",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "HNL",
      "name_plural": "Honduran lempiras"
  },
  "HRK": {
      "symbol": "kn",
      "name": "Croatian Kuna",
      "symbol_native": "kn",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "HRK",
      "name_plural": "Croatian kunas"
  },
  "HUF": {
      "symbol": "Ft",
      "name": "Hungarian Forint",
      "symbol_native": "Ft",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "HUF",
      "name_plural": "Hungarian forints"
  },
  "IDR": {
      "symbol": "Rp",
      "name": "Indonesian Rupiah",
      "symbol_native": "Rp",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "IDR",
      "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
      "symbol": "₪",
      "name": "Israeli New Sheqel",
      "symbol_native": "₪",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "ILS",
      "name_plural": "Israeli new sheqels"
  },
  "INR": {
      "symbol": "Rs",
      "name": "Indian Rupee",
      "symbol_native": "টকা",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "INR",
      "name_plural": "Indian rupees"
  },
  "IQD": {
      "symbol": "IQD",
      "name": "Iraqi Dinar",
      "symbol_native": "د.ع.‏",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "IQD",
      "name_plural": "Iraqi dinars"
  },
  "IRR": {
      "symbol": "IRR",
      "name": "Iranian Rial",
      "symbol_native": "﷼",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "IRR",
      "name_plural": "Iranian rials"
  },
  "ISK": {
      "symbol": "Ikr",
      "name": "Icelandic Króna",
      "symbol_native": "kr",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "ISK",
      "name_plural": "Icelandic krónur"
  },
  "JMD": {
      "symbol": "J$",
      "name": "Jamaican Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "JMD",
      "name_plural": "Jamaican dollars"
  },
  "JOD": {
      "symbol": "JD",
      "name": "Jordanian Dinar",
      "symbol_native": "د.أ.‏",
      "decimal_digits": 3,
      "rounding": 0,
      "code": "JOD",
      "name_plural": "Jordanian dinars"
  },
  "JPY": {
      "symbol": "¥",
      "name": "Japanese Yen",
      "symbol_native": "￥",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "JPY",
      "name_plural": "Japanese yen"
  },
  "KES": {
      "symbol": "Ksh",
      "name": "Kenyan Shilling",
      "symbol_native": "Ksh",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "KES",
      "name_plural": "Kenyan shillings"
  },
  "KHR": {
      "symbol": "KHR",
      "name": "Cambodian Riel",
      "symbol_native": "៛",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "KHR",
      "name_plural": "Cambodian riels"
  },
  "KMF": {
      "symbol": "CF",
      "name": "Comorian Franc",
      "symbol_native": "FC",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "KMF",
      "name_plural": "Comorian francs"
  },
  "KRW": {
      "symbol": "₩",
      "name": "South Korean Won",
      "symbol_native": "₩",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "KRW",
      "name_plural": "South Korean won"
  },
  "KWD": {
      "symbol": "KD",
      "name": "Kuwaiti Dinar",
      "symbol_native": "د.ك.‏",
      "decimal_digits": 3,
      "rounding": 0,
      "code": "KWD",
      "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
      "symbol": "KZT",
      "name": "Kazakhstani Tenge",
      "symbol_native": "тңг.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "KZT",
      "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
      "symbol": "LB£",
      "name": "Lebanese Pound",
      "symbol_native": "ل.ل.‏",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "LBP",
      "name_plural": "Lebanese pounds"
  },
  "LKR": {
      "symbol": "SLRs",
      "name": "Sri Lankan Rupee",
      "symbol_native": "SL Re",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "LKR",
      "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
      "symbol": "Lt",
      "name": "Lithuanian Litas",
      "symbol_native": "Lt",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "LTL",
      "name_plural": "Lithuanian litai"
  },
  "LVL": {
      "symbol": "Ls",
      "name": "Latvian Lats",
      "symbol_native": "Ls",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "LVL",
      "name_plural": "Latvian lati"
  },
  "LYD": {
      "symbol": "LD",
      "name": "Libyan Dinar",
      "symbol_native": "د.ل.‏",
      "decimal_digits": 3,
      "rounding": 0,
      "code": "LYD",
      "name_plural": "Libyan dinars"
  },
  "MAD": {
      "symbol": "MAD",
      "name": "Moroccan Dirham",
      "symbol_native": "د.م.‏",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MAD",
      "name_plural": "Moroccan dirhams"
  },
  "MDL": {
      "symbol": "MDL",
      "name": "Moldovan Leu",
      "symbol_native": "MDL",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MDL",
      "name_plural": "Moldovan lei"
  },
  "MGA": {
      "symbol": "MGA",
      "name": "Malagasy Ariary",
      "symbol_native": "MGA",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "MGA",
      "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
      "symbol": "MKD",
      "name": "Macedonian Denar",
      "symbol_native": "MKD",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MKD",
      "name_plural": "Macedonian denari"
  },
  "MMK": {
      "symbol": "MMK",
      "name": "Myanma Kyat",
      "symbol_native": "K",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "MMK",
      "name_plural": "Myanma kyats"
  },
  "MOP": {
      "symbol": "MOP$",
      "name": "Macanese Pataca",
      "symbol_native": "MOP$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MOP",
      "name_plural": "Macanese patacas"
  },
  "MUR": {
      "symbol": "MURs",
      "name": "Mauritian Rupee",
      "symbol_native": "MURs",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "MUR",
      "name_plural": "Mauritian rupees"
  },
  "MXN": {
      "symbol": "MX$",
      "name": "Mexican Peso",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MXN",
      "name_plural": "Mexican pesos"
  },
  "MYR": {
      "symbol": "RM",
      "name": "Malaysian Ringgit",
      "symbol_native": "RM",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MYR",
      "name_plural": "Malaysian ringgits"
  },
  "MZN": {
      "symbol": "MTn",
      "name": "Mozambican Metical",
      "symbol_native": "MTn",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "MZN",
      "name_plural": "Mozambican meticals"
  },
  "NAD": {
      "symbol": "N$",
      "name": "Namibian Dollar",
      "symbol_native": "N$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NAD",
      "name_plural": "Namibian dollars"
  },
  "NGN": {
      "symbol": "₦",
      "name": "Nigerian Naira",
      "symbol_native": "₦",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NGN",
      "name_plural": "Nigerian nairas"
  },
  "NIO": {
      "symbol": "C$",
      "name": "Nicaraguan Córdoba",
      "symbol_native": "C$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NIO",
      "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
      "symbol": "Nkr",
      "name": "Norwegian Krone",
      "symbol_native": "kr",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NOK",
      "name_plural": "Norwegian kroner"
  },
  "NPR": {
      "symbol": "NPRs",
      "name": "Nepalese Rupee",
      "symbol_native": "नेरू",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NPR",
      "name_plural": "Nepalese rupees"
  },
  "NZD": {
      "symbol": "NZ$",
      "name": "New Zealand Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "NZD",
      "name_plural": "New Zealand dollars"
  },
  "OMR": {
      "symbol": "OMR",
      "name": "Omani Rial",
      "symbol_native": "ر.ع.‏",
      "decimal_digits": 3,
      "rounding": 0,
      "code": "OMR",
      "name_plural": "Omani rials"
  },
  "PAB": {
      "symbol": "B/.",
      "name": "Panamanian Balboa",
      "symbol_native": "B/.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "PAB",
      "name_plural": "Panamanian balboas"
  },
  "PEN": {
      "symbol": "S/.",
      "name": "Peruvian Nuevo Sol",
      "symbol_native": "S/.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "PEN",
      "name_plural": "Peruvian nuevos soles"
  },
  "PHP": {
      "symbol": "₱",
      "name": "Philippine Peso",
      "symbol_native": "₱",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "PHP",
      "name_plural": "Philippine pesos"
  },
  "PKR": {
      "symbol": "PKRs",
      "name": "Pakistani Rupee",
      "symbol_native": "₨",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "PKR",
      "name_plural": "Pakistani rupees"
  },
  "PLN": {
      "symbol": "zł",
      "name": "Polish Zloty",
      "symbol_native": "zł",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "PLN",
      "name_plural": "Polish zlotys"
  },
  "PYG": {
      "symbol": "₲",
      "name": "Paraguayan Guarani",
      "symbol_native": "₲",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "PYG",
      "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
      "symbol": "QR",
      "name": "Qatari Rial",
      "symbol_native": "ر.ق.‏",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "QAR",
      "name_plural": "Qatari rials"
  },
  "RON": {
      "symbol": "RON",
      "name": "Romanian Leu",
      "symbol_native": "RON",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "RON",
      "name_plural": "Romanian lei"
  },
  "RSD": {
      "symbol": "din.",
      "name": "Serbian Dinar",
      "symbol_native": "дин.",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "RSD",
      "name_plural": "Serbian dinars"
  },
  "RUB": {
      "symbol": "•",
      "name": "Russian Ruble",
      "symbol_native": "руб.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "RUB",
      "name_plural": "Russian rubles"
  },
  "RWF": {
      "symbol": "RWF",
      "name": "Rwandan Franc",
      "symbol_native": "FR",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "RWF",
      "name_plural": "Rwandan francs"
  },
  "SAR": {
      "symbol": "SR",
      "name": "Saudi Riyal",
      "symbol_native": "ر.س.‏",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "SAR",
      "name_plural": "Saudi riyals"
  },
  "SDG": {
      "symbol": "SDG",
      "name": "Sudanese Pound",
      "symbol_native": "SDG",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "SDG",
      "name_plural": "Sudanese pounds"
  },
  "SEK": {
      "symbol": "Skr",
      "name": "Swedish Krona",
      "symbol_native": "kr",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "SEK",
      "name_plural": "Swedish kronor"
  },
  "SGD": {
      "symbol": "S$",
      "name": "Singapore Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "SGD",
      "name_plural": "Singapore dollars"
  },
  "SOS": {
      "symbol": "Ssh",
      "name": "Somali Shilling",
      "symbol_native": "Ssh",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "SOS",
      "name_plural": "Somali shillings"
  },
  "SYP": {
      "symbol": "SY£",
      "name": "Syrian Pound",
      "symbol_native": "ل.س.‏",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "SYP",
      "name_plural": "Syrian pounds"
  },
  "THB": {
      "symbol": "฿",
      "name": "Thai Baht",
      "symbol_native": "฿",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "THB",
      "name_plural": "Thai baht"
  },
  "TND": {
      "symbol": "DT",
      "name": "Tunisian Dinar",
      "symbol_native": "د.ت.‏",
      "decimal_digits": 3,
      "rounding": 0,
      "code": "TND",
      "name_plural": "Tunisian dinars"
  },
  "TOP": {
      "symbol": "T$",
      "name": "Tongan Paʻanga",
      "symbol_native": "T$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "TOP",
      "name_plural": "Tongan paʻanga"
  },
  "TRY": {
      "symbol": "TL",
      "name": "Turkish Lira",
      "symbol_native": "TL",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "TRY",
      "name_plural": "Turkish Lira"
  },
  "TTD": {
      "symbol": "TT$",
      "name": "Trinidad and Tobago Dollar",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "TTD",
      "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
      "symbol": "NT$",
      "name": "New Taiwan Dollar",
      "symbol_native": "NT$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "TWD",
      "name_plural": "New Taiwan dollars"
  },
  "TZS": {
      "symbol": "TSh",
      "name": "Tanzanian Shilling",
      "symbol_native": "TSh",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "TZS",
      "name_plural": "Tanzanian shillings"
  },
  "UAH": {
      "symbol": "₴",
      "name": "Ukrainian Hryvnia",
      "symbol_native": "₴",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "UAH",
      "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
      "symbol": "USh",
      "name": "Ugandan Shilling",
      "symbol_native": "USh",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "UGX",
      "name_plural": "Ugandan shillings"
  },
  "UYU": {
      "symbol": "$U",
      "name": "Uruguayan Peso",
      "symbol_native": "$",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "UYU",
      "name_plural": "Uruguayan pesos"
  },
  "UZS": {
      "symbol": "UZS",
      "name": "Uzbekistan Som",
      "symbol_native": "UZS",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "UZS",
      "name_plural": "Uzbekistan som"
  },
  "VEF": {
      "symbol": "Bs.F.",
      "name": "Venezuelan Bolívar",
      "symbol_native": "Bs.F.",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "VEF",
      "name_plural": "Venezuelan bolívars"
  },
  "VND": {
      "symbol": "₫",
      "name": "Vietnamese Dong",
      "symbol_native": "₫",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "VND",
      "name_plural": "Vietnamese dong"
  },
  "XAF": {
      "symbol": "FCFA",
      "name": "CFA Franc BEAC",
      "symbol_native": "FCFA",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "XAF",
      "name_plural": "CFA francs BEAC"
  },
  "XOF": {
      "symbol": "CFA",
      "name": "CFA Franc BCEAO",
      "symbol_native": "CFA",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "XOF",
      "name_plural": "CFA francs BCEAO"
  },
  "YER": {
      "symbol": "YR",
      "name": "Yemeni Rial",
      "symbol_native": "ر.ي.‏",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "YER",
      "name_plural": "Yemeni rials"
  },
  "ZAR": {
      "symbol": "R",
      "name": "South African Rand",
      "symbol_native": "R",
      "decimal_digits": 2,
      "rounding": 0,
      "code": "ZAR",
      "name_plural": "South African rand"
  },
  "ZMK": {
      "symbol": "ZK",
      "name": "Zambian Kwacha",
      "symbol_native": "ZK",
      "decimal_digits": 0,
      "rounding": 0,
      "code": "ZMK",
      "name_plural": "Zambian kwachas"
  }
}